import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import API from '../services/api';

export default function ClienteForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const editando = !!id;
  const [form, setForm] = useState({ nombre: '', contacto: '', email: '', telefono: '', cif: '', direccion: '', notas: '' });
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (editando) {
      API.get('/clientes').then(res => {
        const c = res.data.find(x => x.id === parseInt(id));
        if (c) setForm({ nombre: c.nombre||'', contacto: c.contacto||'', email: c.email||'', telefono: c.telefono||'', cif: c.cif||'', direccion: c.direccion||'', notas: c.notas||'' });
      });
    }
  }, [id]);

  const guardar = async () => {
    setError('');
    if (!form.nombre.trim()) { setError('El nombre es obligatorio'); return; }
    setGuardando(true);
    try {
      const payload = { nombre: form.nombre, contacto: form.contacto||null, email: form.email||null, telefono: form.telefono||null, cif: form.cif||null, direccion: form.direccion||null, notas: form.notas||null };
      if (editando) {
        await API.put(`/clientes/${id}`, payload);
        navigate(`/clientes/${id}`);
      } else {
        const res = await API.post('/clientes', payload);
        navigate(`/clientes/${res.data.id}`);
      }
    } catch(e) {
      setError(e.response?.data?.detail || e.message || JSON.stringify(e.response?.data) || 'Error al guardar');
      setGuardando(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate(editando ? `/clientes/${id}` : '/clientes')}>
          ← {editando ? 'Cliente' : 'Clientes'}
        </button>
      </div>
      <div style={s.content}>
        <div style={s.card}>
          <div style={s.cardTitle}>{editando ? 'Editar cliente' : 'Nuevo cliente'}</div>
          {error && <div style={s.errorBox}>{error}</div>}
          <div style={s.field}><label style={s.label}>Nombre *</label><input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Nombre de la empresa o cliente" autoFocus /></div>
          <div style={s.field}><label style={s.label}>Persona de contacto</label><input style={s.input} value={form.contacto} onChange={e => setForm({...form, contacto: e.target.value})} placeholder="Nombre del contacto principal" /></div>
          <div style={s.fieldRow}>
            <div style={{...s.field, flex:1}}><label style={s.label}>Email</label><input style={s.input} value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="email@empresa.com" /></div>
            <div style={{...s.field, flex:1}}><label style={s.label}>Teléfono</label><input style={s.input} value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="+34 600 000 000" /></div>
          </div>
          <div style={s.fieldRow}>
            <div style={{...s.field, flex:1}}><label style={s.label}>CIF / NIF</label><input style={s.input} value={form.cif} onChange={e => setForm({...form, cif: e.target.value})} placeholder="B12345678" /></div>
            <div style={{...s.field, flex:1}}><label style={s.label}>Dirección</label><input style={s.input} value={form.direccion} onChange={e => setForm({...form, direccion: e.target.value})} placeholder="Calle, ciudad..." /></div>
          </div>
          <div style={s.field}><label style={s.label}>Notas</label><textarea style={{...s.input, height:96, resize:'vertical'}} value={form.notas} onChange={e => setForm({...form, notas: e.target.value})} placeholder="Notas internas sobre este cliente" /></div>
          <div style={s.footer}>
            <button style={s.btnSecondary} onClick={() => navigate(editando ? `/clientes/${id}` : '/clientes')}>Cancelar</button>
            <button style={s.btn} onClick={guardar} disabled={guardando}>{guardando ? 'Guardando...' : editando ? 'Guardar cambios' : 'Crear cliente'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center' },
  backBtn: { background:'none', border:'none', fontSize:13, color:'#378ADD', cursor:'pointer', fontWeight:500 },
  content: { padding:24, maxWidth:600 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:24 },
  cardTitle: { fontSize:16, fontWeight:600, color:'#1a1a1a', marginBottom:24 },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  footer: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24, paddingTop:16, borderTop:'0.5px solid #f0f0ed' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
};
